var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',{staticClass:"container body-content"},[_c('h2',[_vm._v("My Sessions")]),_c('p',[_vm._v("This is the My Sessions page.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }